import Router from "next/router"
import { useEffect, useRef } from "react"
import { logPageView } from "./browserLogs"

/**
 * 初回表示とクライアント遷移のたびに page_view ログを送る。
 * route は `/admin/stores/[store_id]` のような pattern で送り、実際の path（ID や token を含みうる）は送らない。
 */
export const usePageViewLog = () => {
  const previousRouteRef = useRef<string>()

  useEffect(() => {
    const handleRouteChange = () => {
      const route = Router.pathname
      logPageView({ route, fromRoute: previousRouteRef.current })
      previousRouteRef.current = route
    }

    handleRouteChange()
    Router.events.on("routeChangeComplete", handleRouteChange)
    return () => {
      Router.events.off("routeChangeComplete", handleRouteChange)
    }
  }, [])
}
